<template>
  <UiConfirmationModal
    v-if="leaveConfirmState.pending"
    :message="leaveConfirmState.pending.message"
    @confirmAction="answerLeave(true)"
    @cancelAction="answerLeave(false)"
  />
</template>

<script setup lang="ts">
import UiConfirmationModal from '@/shared/components/ui/UiConfirmationModal.vue'

import { answerLeave, leaveConfirmState } from './leaveConfirm'
</script>
